(function() {
  const state = {
    loading: false,
    loaded: false,
    error: null,
    data: null,
    productStore: null,
    promise: null,
    cacheByProductKey: {},
    promiseByCacheKey: {}
  };

  const DEFAULT_API_BASE_URL = "https://ws-api.chantillyapps.cl";

  function normalizeApiBaseUrl(value) {
    return (value || "").toString().trim().replace(/\/+$/, "");
  }

  function getDatasetApiBaseUrl(node) {
    if (!node || !node.dataset) return "";
    return normalizeApiBaseUrl(node.dataset.cotizadorApiBaseUrl);
  }

  function getApiBaseUrl(container) {
    return getDatasetApiBaseUrl(container) ||
      getDatasetApiBaseUrl(container && container.closest ? container.closest("[data-cotizador-api-base-url]") : null) ||
      getDatasetApiBaseUrl(document.querySelector(".cotiza51[data-cotizador-api-base-url]")) ||
      getDatasetApiBaseUrl(document.querySelector(".cotiza-cortina[data-cotizador-api-base-url]")) ||
      DEFAULT_API_BASE_URL;
  }

  function normalizeBasicAuthHeader(value) {
    const credential = (value || "").toString().trim();
    if (!credential) return "";
    return credential.toLowerCase().startsWith("basic ") ? credential : `Basic ${credential}`;
  }

  function getDatasetBasicAuthHeader(node) {
    if (!node || !node.dataset) return "";
    return normalizeBasicAuthHeader(node.dataset.cotizadorApiBasicAuth);
  }

  function getBasicAuthHeader(container) {
    return getDatasetBasicAuthHeader(container) ||
      getDatasetBasicAuthHeader(container && container.closest ? container.closest("[data-cotizador-api-basic-auth]") : null) ||
      getDatasetBasicAuthHeader(document.querySelector(".cotiza51[data-cotizador-api-basic-auth]")) ||
      getDatasetBasicAuthHeader(document.querySelector(".cotiza-cortina[data-cotizador-api-basic-auth]"));
  }

  function buildCotizadorHeaders(container, hasBody) {
    const headers = { Accept: "application/json" };
    const basicAuthHeader = getBasicAuthHeader(container);

    if (hasBody) {
      headers["Content-Type"] = "application/json";
    }

    if (basicAuthHeader) {
      headers.Authorization = basicAuthHeader;
    }

    return headers;
  }

  function getStatusContainer(container) {
    return container || document.querySelector(".cotiza-cortina") || document.querySelector(".cotiza51");
  }

  function setCotizadorBootstrapStatus(container, type, message) {
    const statusContainer = getStatusContainer(container);
    if (!statusContainer) return;

    let statusNode = statusContainer.querySelector(".cotizador-bootstrap-status");
    if (!message) {
      if (statusNode) statusNode.remove();
      return;
    }

    if (!statusNode) {
      statusNode = document.createElement("div");
      statusNode.className = "cotizador-bootstrap-status";
      statusNode.setAttribute("role", type === "error" ? "alert" : "status");
      statusContainer.prepend(statusNode);
    }

    statusNode.dataset.status = type || "info";
    statusNode.textContent = message;
  }

  function getStoreCode() {
    if (!window.Shopify || !window.Shopify.shop) return "";
    return window.Shopify.shop.split(".")[0];
  }

  function getStoreEmailFallback() {
    const store = (window.Shopify && window.Shopify.shop) ? window.Shopify.shop : "example.invalid";
    return `cotizador@${store}`;
  }

  function getCotizadorProductKeys(container) {
    const main = document.querySelector(".cotiza51[data-cotizador]");
    const rawKeys = [];

    if (main && main.dataset && main.dataset.cotizador) {
      rawKeys.push(main.dataset.cotizador);
    }

    if (container && container.dataset && container.dataset.cotizadorProductKeys) {
      rawKeys.push(...container.dataset.cotizadorProductKeys.split(","));
    }

    return rawKeys
      .map(value => (value || "").toString().trim().toLowerCase())
      .filter((value, index, values) => value && values.indexOf(value) === index);
  }

  function getBootstrapCacheKey(productKeys) {
    return productKeys.slice().sort().join("|");
  }

  function buildBootstrapUrl(apiBaseUrl, productKeys) {
    const url = new URL(`${apiBaseUrl}/api/v3/cotizador-b2c/bootstrap`, window.location.origin);
    productKeys.forEach(productKey => url.searchParams.append("productKey", productKey));
    return url.toString();
  }

  function getBootstrapItemProductKey(item) {
    return (item && item.productKey ? item.productKey : "").toString().trim().toLowerCase();
  }

  function getBootstrapItemSku(item) {
    return (item && item.sku ? item.sku : "").toString().trim().toUpperCase();
  }

  const PRODUCT_GROUP_KEYS = {
    normalProducts: "normal-products",
    duoProducts: "duo-products",
    tradicionalProducts: "tradicional-products",
    maderaProducts: "madera-products",
    metalProducts: "metal-products"
  };

  function emptyProductGroups() {
    return {
      normalProducts: [],
      duoProducts: [],
      tradicionalProducts: [],
      maderaProducts: [],
      metalProducts: []
    };
  }

  function emptyBootstrapPayload() {
    return {
      catalog: [],
      stock: [],
      componentes: [],
      products: [],
      productGroups: emptyProductGroups()
    };
  }

  function filterBootstrapItemsByProductKey(items, productKey) {
    if (!Array.isArray(items)) return [];
    const matchingItems = items.filter(item => getBootstrapItemProductKey(item) === productKey);
    return matchingItems.length > 0 ? matchingItems : items;
  }

  function getSortOrderValue(item) {
    const sortOrder = item && item.sortOrder;
    const numericSortOrder = Number(sortOrder);
    return Number.isFinite(numericSortOrder) ? numericSortOrder : Number.MAX_SAFE_INTEGER;
  }

  function getSortNameValue(item) {
    return ((item && (item.name || item.descripcionSoftland || item.sku)) || "").toString();
  }

  function sortBootstrapCollection(items) {
    return (Array.isArray(items) ? items.slice() : []).sort((a, b) => {
      const sortOrderDiff = getSortOrderValue(a) - getSortOrderValue(b);
      if (sortOrderDiff !== 0) return sortOrderDiff;
      return getSortNameValue(a).localeCompare(getSortNameValue(b), "es");
    });
  }

  function buildProductGroups(products) {
    const groups = emptyProductGroups();
    (Array.isArray(products) ? products : []).forEach(product => {
      const matchingGroupKey = Object.keys(PRODUCT_GROUP_KEYS)
        .find(groupKey => PRODUCT_GROUP_KEYS[groupKey] === product.containerClass);
      if (matchingGroupKey) groups[matchingGroupKey].push(product);
    });
    return groups;
  }

  function buildStockForItems(bootstrap, catalogItems, componentItems, productKey) {
    const stock = bootstrap && Array.isArray(bootstrap.stock) ? bootstrap.stock : [];
    const matchingStock = stock.filter(item => getBootstrapItemProductKey(item) === productKey);
    if (matchingStock.length > 0) return matchingStock;

    const usedSkus = new Set(
      catalogItems
        .concat(componentItems)
        .map(getBootstrapItemSku)
        .filter(Boolean)
    );

    if (usedSkus.size === 0) return stock;
    return stock.filter(item => usedSkus.has(getBootstrapItemSku(item)));
  }

  function normalizeBootstrapForProductKey(bootstrap, productKey, requestedProductKeys) {
    const requestedSingleKey = requestedProductKeys.length === 1;
    const catalogItems = requestedSingleKey
      ? (bootstrap && Array.isArray(bootstrap.catalog) ? bootstrap.catalog : [])
      : filterBootstrapItemsByProductKey(bootstrap && bootstrap.catalog, productKey);
    const componentItems = requestedSingleKey
      ? (bootstrap && Array.isArray(bootstrap.componentes) ? bootstrap.componentes : [])
      : filterBootstrapItemsByProductKey(bootstrap && bootstrap.componentes, productKey);
    const productItems = requestedSingleKey
      ? getBootstrapThemeProducts(bootstrap)
      : filterBootstrapItemsByProductKey(getBootstrapThemeProducts(bootstrap), productKey);

    return {
      ...emptyBootstrapPayload(),
      ...bootstrap,
      catalog: sortBootstrapCollection(catalogItems),
      componentes: sortBootstrapCollection(componentItems),
      products: sortBootstrapCollection(productItems),
      productGroups: buildProductGroups(productItems),
      stock: requestedSingleKey
        ? sortBootstrapCollection(bootstrap && Array.isArray(bootstrap.stock) ? bootstrap.stock : [])
        : sortBootstrapCollection(buildStockForItems(bootstrap, catalogItems, componentItems, productKey))
    };
  }

  function cacheBootstrapByProductKey(bootstrap, productKeys) {
    productKeys.forEach(productKey => {
      state.cacheByProductKey[productKey] = normalizeBootstrapForProductKey(bootstrap, productKey, productKeys);
    });
  }

  function mergeBootstrapPayloads(payloads) {
    const merged = emptyBootstrapPayload();
    const seen = {
      catalog: new Set(),
      stock: new Set(),
      componentes: new Set(),
      products: new Set()
    };

    payloads.forEach(payload => {
      ["catalog", "stock", "componentes", "products"].forEach(collectionName => {
        const collection = collectionName === "products"
          ? getBootstrapThemeProducts(payload)
          : (payload && Array.isArray(payload[collectionName]) ? payload[collectionName] : []);
        collection.forEach(item => {
          const key = getBootstrapItemSku(item) || `${getBootstrapItemProductKey(item)}:${item.className || item.key || item.name || JSON.stringify(item)}`;
          if (seen[collectionName].has(key)) return;
          seen[collectionName].add(key);
          merged[collectionName].push(item);
        });
      });
    });

    merged.catalog = sortBootstrapCollection(merged.catalog);
    merged.stock = sortBootstrapCollection(merged.stock);
    merged.componentes = sortBootstrapCollection(merged.componentes);
    merged.products = sortBootstrapCollection(merged.products);
    merged.productGroups = buildProductGroups(merged.products);

    return merged;
  }

  function getCachedBootstrap(productKeys) {
    const payloads = productKeys.map(productKey => state.cacheByProductKey[productKey]).filter(Boolean);
    if (payloads.length !== productKeys.length) return null;
    return mergeBootstrapPayloads(payloads);
  }

  function getSkuKey(value) {
    return (value || "").toString().trim().toUpperCase();
  }

  function getSoftlandSku(softland) {
    if (!softland) return "";
    return (softland.codRapido || softland.codBarra || "").toString().trim();
  }

  function toHandle(value) {
    return (value || "")
      .toString()
      .trim()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function setDatasetValue(node, key, value, transform) {
    if (value === undefined || value === null || value === "") return;
    node.dataset[key] = transform ? transform(value) : value.toString();
  }

  function resolvePrice(catalogItem, stockItem, componentItem) {
    if (stockItem && Number.isFinite(Number(stockItem.price))) {
      return Number(stockItem.price);
    }

    if (catalogItem && Number.isFinite(Number(catalogItem.price))) {
      return Number(catalogItem.price);
    }

    if (componentItem && Number.isFinite(Number(componentItem.price))) {
      return Number(componentItem.price);
    }

    return null;
  }

  function resolveDescription(catalogItem, stockItem, componentItem) {
    return (
      (stockItem && stockItem.description) ||
      (catalogItem && catalogItem.descripcionSoftland) ||
      (catalogItem && catalogItem.name) ||
      (componentItem && componentItem.name) ||
      ""
    ).toString().trim();
  }

  function applyImagesToNode(node, images) {
    if (!images) return;

    const primary = images.primary || null;
    const secondary = images.secondary || primary;

    if (secondary) {
      setDatasetValue(node, "productImage", secondary.previewUrl);
      setDatasetValue(node, "productImageZoom", secondary.zoomUrl);
    }

    if (primary) {
      setDatasetValue(node, "productImageExtra", primary.previewUrl);
      setDatasetValue(node, "productImageExtraZoom", primary.zoomUrl);
      setDatasetValue(node, "productImageTiny", primary.tinyUrl);
    }
  }

  function getProductContainerClass(node) {
    const containerClasses = ["normal-products", "duo-products", "tradicional-products", "madera-products", "metal-products"];
    const container = node && node.closest ? node.closest(containerClasses.map(className => `.${className}`).join(",")) : null;
    if (!container) return "";
    return containerClasses.find(className => container.classList.contains(className)) || "";
  }

  function getNodeProductClassName(node) {
    if (!node || !node.classList) return "";
    return Array.from(node.classList).find(className => className.indexOf("product-") === 0) || "";
  }

  function getProductTypeSuffix(containerClass, className) {
    const suffixByContainer = {
      "duo-products": "-duo",
      "tradicional-products": "-tradicional",
      "madera-products": "-madera",
      "metal-products": "-metal"
    };

    const suffix = suffixByContainer[containerClass] || "";
    return suffix && className.endsWith(suffix) ? suffix : "";
  }

  function getBlockTypeFromClassName(className, productTypeSuffix) {
    if (!className || className.indexOf("product-") !== 0) return "";
    const withoutPrefix = className.replace(/^product-/, "");
    const withoutSuffix = productTypeSuffix && withoutPrefix.endsWith(productTypeSuffix.replace(/^-/, ""))
      ? withoutPrefix.slice(0, -productTypeSuffix.length)
      : withoutPrefix;
    return withoutSuffix.replace(/-+$/, "").replace(/-/g, "_");
  }

  function normalizeProductDataset(dataset) {
    const normalizedDataset = Object.keys(dataset || {}).reduce((normalized, key) => {
      normalized[key] = dataset[key];
      return normalized;
    }, {});

    if (!normalizedDataset.productColor && normalizedDataset.productSku) {
      normalizedDataset.productColor = `sku-${toHandle(normalizedDataset.productSku)}`;
    }

    if (!normalizedDataset.productColorFull) {
      normalizedDataset.productColorFull =
        normalizedDataset.productTitle ||
        normalizedDataset.descripcionSoftland ||
        normalizedDataset.productSku ||
        normalizedDataset.productColor ||
        "";
    }

    return normalizedDataset;
  }

  function normalizeDomProductNode(node) {
    const containerClass = getProductContainerClass(node);
    const className = getNodeProductClassName(node);
    const productTypeSuffix = getProductTypeSuffix(containerClass, className);
    const productKeyByContainer = {
      "normal-products": "roller",
      "duo-products": "roller",
      "tradicional-products": "tradicional",
      "madera-products": "madera",
      "metal-products": "metal"
    };

    return {
      source: "dom",
      productKey: productKeyByContainer[containerClass] || "",
      containerClass,
      blockType: getBlockTypeFromClassName(className, productTypeSuffix),
      productTypeSuffix,
      name: node.name || "",
      className,
      value: Number.isFinite(Number(node.value)) ? Number(node.value) : 0,
      dataset: normalizeProductDataset(node.dataset)
    };
  }

  function normalizeBootstrapProductRecord(record) {
    const dataset = normalizeProductDataset(record && record.dataset);

    return {
      source: "ws",
      productKey: (record && record.productKey || "").toString(),
      containerClass: (record && record.containerClass || "").toString(),
      blockType: (record && record.blockType || "").toString(),
      productTypeSuffix: (record && record.productTypeSuffix || "").toString(),
      name: (record && record.name || "").toString(),
      className: (record && record.className || "").toString(),
      value: Number.isFinite(Number(record && record.value)) ? Number(record.value) : 0,
      dataset
    };
  }

  function setThemeProductDatasetValue(node, key, value) {
    if (value === undefined || value === null || value === "") return;
    node.dataset[key] = value.toString();
  }

  function upsertThemeProductNode(product) {
    if (!product || !product.containerClass || !product.className) return null;

    const container = document.querySelector(`.${product.containerClass}`);
    if (!container) return null;

    const dataset = normalizeProductDataset(product.dataset);
    const sku = (dataset.productSku || "").toString().trim();
    const selector = product.name
      ? `.${product.className}[name='${product.name}']`
      : `.${product.className}[data-product-sku='${sku}']`;

    let node = container.querySelector(selector);
    if (!node) {
      node = document.createElement("input");
      node.type = "hidden";
      node.name = product.name || `producto-bootstrap-${product.className}-${sku || Date.now()}`;
      node.className = product.className;
      node.dataset.bootstrapThemeProduct = "true";
      container.appendChild(node);
    }

    node.value = `${Math.round(product.value || 0)}`;
    Object.keys(dataset).forEach(key => setThemeProductDatasetValue(node, key, dataset[key]));
    return node;
  }

  function upsertThemeProductNodesFromBootstrap(bootstrap) {
    return getBootstrapThemeProducts(bootstrap)
      .map(normalizeBootstrapProductRecord)
      .map(upsertThemeProductNode)
      .filter(Boolean);
  }

  function buildCotizadorProductStore(products, source) {
    const normalizedProducts = (Array.isArray(products) ? products : []).filter(product => product && product.className);
    const bySku = {};
    const byClassName = {};
    const byContainerClass = {};
    const productGroups = buildProductGroups(normalizedProducts);

    normalizedProducts.forEach(product => {
      const sku = (product.dataset && product.dataset.productSku || "").toString().trim().toUpperCase();
      if (sku) bySku[sku] = product;

      if (!byClassName[product.className]) byClassName[product.className] = [];
      byClassName[product.className].push(product);

      if (!byContainerClass[product.containerClass]) byContainerClass[product.containerClass] = [];
      byContainerClass[product.containerClass].push(product);
    });

    return {
      source: source || "dom",
      products: normalizedProducts,
      productGroups,
      bySku,
      byClassName,
      byContainerClass
    };
  }

  function setCotizadorProductStore(productStore) {
    state.productStore = productStore;
    window.cotizadorB2CProductStore = productStore;
    return productStore;
  }

  function getBootstrapThemeProducts(bootstrap) {
    if (!bootstrap) return [];
    if (Array.isArray(bootstrap.products)) return bootstrap.products;
    const groupedProducts = getBootstrapThemeProductGroups(bootstrap);
    if (groupedProducts.length > 0) return groupedProducts;
    if (Array.isArray(bootstrap.themeProducts)) return bootstrap.themeProducts;
    if (Array.isArray(bootstrap.productsForTheme)) return bootstrap.productsForTheme;
    return [];
  }

  function getBootstrapThemeProductGroups(bootstrap) {
    const groups = bootstrap && bootstrap.productGroups;
    if (!groups || typeof groups !== "object") return [];
    return Object.keys(PRODUCT_GROUP_KEYS).reduce((products, groupKey) => {
      const groupProducts = Array.isArray(groups[groupKey]) ? groups[groupKey] : [];
      return products.concat(groupProducts);
    }, []);
  }

  function setCotizadorProductStoreFromBootstrap(bootstrap) {
    const products = getBootstrapThemeProducts(bootstrap).map(normalizeBootstrapProductRecord);
    if (products.length === 0) return null;
    return setCotizadorProductStore(buildCotizadorProductStore(products, "ws"));
  }

  function refreshCotizadorProductStoreFromDom(root) {
    const scope = root || document;
    const products = Array.from(scope.querySelectorAll(
      ".tradicional-products [data-product-sku], .metal-products [data-product-sku], .madera-products [data-product-sku], .normal-products [data-product-sku], .duo-products [data-product-sku]"
    )).map(normalizeDomProductNode);

    return setCotizadorProductStore(buildCotizadorProductStore(products, "dom"));
  }

  function getCotizadorProductStore() {
    return state.productStore || window.cotizadorB2CProductStore || null;
  }

  function productMatchesFilters(product, filters) {
    const currentFilters = filters || {};
    const dataset = product && product.dataset ? product.dataset : {};

    return Object.keys(currentFilters).every(key => {
      const expected = currentFilters[key];
      if (expected === undefined || expected === null || expected === "") return true;
      if (key === "productKey" || key === "containerClass" || key === "className" || key === "blockType" || key === "productTypeSuffix" || key === "name") {
        return product[key] === expected;
      }
      return dataset[key] === expected;
    });
  }

  function findCotizadorProducts(filters) {
    const productStore = getCotizadorProductStore();
    const products = productStore && Array.isArray(productStore.products) ? productStore.products : [];
    return products.filter(product => productMatchesFilters(product, filters));
  }

  function findCotizadorProduct(filters) {
    const products = findCotizadorProducts(filters);
    return products.length > 0 ? products[0] : null;
  }

  function findCotizadorProductGroup(groupKey, filters) {
    const productStore = getCotizadorProductStore();
    const groups = productStore && productStore.productGroups ? productStore.productGroups : {};
    const groupedProducts = Array.isArray(groups[groupKey]) ? groups[groupKey] : [];
    const products = groupedProducts.length > 0 ? groupedProducts : findCotizadorProducts({});
    return products.filter(product => productMatchesFilters(product, filters));
  }

  function mapBootstrapBySku(bootstrap) {
    const catalog = bootstrap && Array.isArray(bootstrap.catalog) ? bootstrap.catalog : [];
    const stock = bootstrap && Array.isArray(bootstrap.stock) ? bootstrap.stock : [];
    const componentes = bootstrap && Array.isArray(bootstrap.componentes) ? bootstrap.componentes : [];

    return {
      catalogBySku: new Map(catalog.map(item => [getSkuKey(item.sku), item])),
      stockBySku: new Map(stock.map(item => [getSkuKey(item.sku), item])),
      componentBySku: new Map(componentes.map(item => [getSkuKey(item.sku), item]))
    };
  }

  function getComponentKey(value) {
    return (value || "")
      .toString()
      .trim()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/([a-z0-9])([A-Z])/g, "$1_$2")
      .replace(/[^a-zA-Z0-9]+/g, "_")
      .replace(/^_+|_+$/g, "")
      .toLowerCase();
  }

  function buildComponentKeyMap(bootstrap) {
    const componentes = bootstrap && Array.isArray(bootstrap.componentes) ? bootstrap.componentes : [];
    const byProductKey = new Map();

    componentes.forEach(item => {
      const productKey = getComponentKey(item.productKey);
      const key = getComponentKey(item.key);
      if (!productKey || !key) return;

      if (!byProductKey.has(productKey)) {
        byProductKey.set(productKey, new Map());
      }

      byProductKey.get(productKey).set(key, item);
    });

    return byProductKey;
  }

  function resolveProductNodes() {
    return document.querySelectorAll(
      ".tradicional-products [data-product-sku], .metal-products [data-product-sku], .madera-products [data-product-sku], .normal-products [data-product-sku], .duo-products [data-product-sku]"
    );
  }

  function applyCotizadorBootstrapToDom(bootstrap) {
    upsertThemeProductNodesFromBootstrap(bootstrap);

    const { catalogBySku, stockBySku, componentBySku } = mapBootstrapBySku(bootstrap);
    const componentByProductKey = buildComponentKeyMap(bootstrap);

    window.cotizadorBootstrapCatalogBySku = catalogBySku;
    window.cotizadorBootstrapStockBySku = stockBySku;
    window.cotizadorBootstrapComponentBySku = componentBySku;
    window.cotizadorBootstrapComponentByProductKey = componentByProductKey;

    resolveProductNodes().forEach(node => {
      const skuKey = getSkuKey(node.dataset.productSku);
      if (!skuKey) return;

      const catalogItem = catalogBySku.get(skuKey);
      const stockItem = stockBySku.get(skuKey);
      const componentItem = componentBySku.get(skuKey);

      if (catalogItem || stockItem || componentItem) {
        const price = resolvePrice(catalogItem, stockItem, componentItem);
        if (price !== null) {
          node.value = `${Math.round(price)}`;
        }
      }

      if (catalogItem) {
        setDatasetValue(node, "productTitle", catalogItem.name);
        setDatasetValue(node, "productTela", catalogItem.categoria, toHandle);
        setDatasetValue(node, "productTipo", catalogItem.subtipo, toHandle);
        setDatasetValue(node, "productColor", catalogItem.color, toHandle);
        setDatasetValue(node, "productColorFull", catalogItem.colorFull || catalogItem.color);
        setDatasetValue(node, "skuSoftland", catalogItem.skuSoftland || getSoftlandSku(catalogItem.softland));
        setDatasetValue(node, "descripcionSoftland", resolveDescription(catalogItem, stockItem, null));
        setDatasetValue(node, "productWeight", catalogItem.weight);
        setDatasetValue(node, "productWeightUnit", catalogItem.weightUnit);
        setDatasetValue(node, "sortOrder", catalogItem.sortOrder);
        applyImagesToNode(node, catalogItem.images);
      } else if (componentItem) {
        setDatasetValue(node, "productTitle", componentItem.name);
        setDatasetValue(node, "skuSoftland", componentItem.skuSoftland || getSoftlandSku(componentItem.softland));
        setDatasetValue(node, "descripcionSoftland", componentItem.descripcionSoftland || resolveDescription(null, null, componentItem));
        setDatasetValue(node, "productWeight", componentItem.weight);
        setDatasetValue(node, "productWeightUnit", componentItem.weightUnit);
        setDatasetValue(node, "compareAtPrice", componentItem.compareAtPrice);
      } else if (stockItem) {
        setDatasetValue(node, "descripcionSoftland", resolveDescription(null, stockItem, null));
      }

      if (componentItem && Number.isFinite(Number(componentItem.quantity))) {
        const quantity = Number(componentItem.quantity);
        node.dataset.productQuantity = `${quantity}`;
        node.dataset.productAvailable = componentItem.available === true || quantity > 0 ? "true" : "false";
      } else if (stockItem && Number.isFinite(Number(stockItem.quantity))) {
        const quantity = Number(stockItem.quantity);
        node.dataset.productQuantity = `${quantity}`;
        node.dataset.productAvailable = quantity > 0 ? "true" : "false";
      }
    });

    if (getBootstrapThemeProducts(bootstrap).length > 0) {
      setCotizadorProductStoreFromBootstrap(bootstrap);
    } else {
      refreshCotizadorProductStoreFromDom(document);
    }
  }
  async function fetchCotizadorBootstrap(options) {
    const opts = options || {};
    const container = opts.container || document.querySelector(".cotiza-cortina");
    const apiBaseUrl = getApiBaseUrl(container);

    if (!apiBaseUrl) {
      return null;
    }

    const productKeys = getCotizadorProductKeys(container);
    if (productKeys.length === 0) {
      return null;
    }

    const cacheKey = getBootstrapCacheKey(productKeys);
    const cachedBootstrap = getCachedBootstrap(productKeys);

    if (cachedBootstrap) {
      state.data = cachedBootstrap;
      state.loaded = true;
      setCotizadorProductStoreFromBootstrap(state.data);
      return cachedBootstrap;
    }

    if (state.promiseByCacheKey[cacheKey]) {
      return state.promiseByCacheKey[cacheKey];
    }

    state.loading = true;
    state.error = null;
    setCotizadorBootstrapStatus(container, "loading", "Cargando datos del cotizador...");

    const bootstrapUrl = buildBootstrapUrl(apiBaseUrl, productKeys);

    state.promise = fetch(bootstrapUrl, {
      method: "GET",
      headers: buildCotizadorHeaders(container),
      credentials: "omit"
    })
      .then(response => {
        if (!response.ok) throw new Error(`Bootstrap request failed: ${response.status}`);
        return response.json();
      })
      .then(bootstrap => {
        cacheBootstrapByProductKey(bootstrap, productKeys);
        state.data = getCachedBootstrap(productKeys) || bootstrap;
        state.loaded = true;
        setCotizadorProductStoreFromBootstrap(state.data);
        setCotizadorBootstrapStatus(container, null, "");
        return state.data;
      })
      .catch(error => {
        state.error = error;
        console.error("No se pudo cargar bootstrap v3 del cotizador", error);
        setCotizadorBootstrapStatus(container, "error", "No se pudieron cargar los datos del cotizador. Intenta recargar la página.");
        return null;
      })
      .finally(() => {
        state.loading = false;
        state.promise = null;
        delete state.promiseByCacheKey[cacheKey];
      });

    state.promiseByCacheKey[cacheKey] = state.promise;
    return state.promise;
  }

  function parseNumeric(value, fallback) {
    const num = Number(value);
    if (Number.isFinite(num)) return num;
    return fallback;
  }

  function getActiveHiddenProductContainers(root) {
    const productRoot = root.querySelector(".hidden_selected_products") ? root : document;
    const cotizadorNode = document.querySelector(".cotiza51[data-cotizador]");
    const cortinaTypeNode = document.querySelector("input[name='form-cortina-tipo']");
    const cotizadorKey = (cotizadorNode && cotizadorNode.dataset ? cotizadorNode.dataset.cotizador : "").trim().toLowerCase();
    const selectedCortinaType = (cortinaTypeNode ? cortinaTypeNode.value : "").trim().toLowerCase();
    const classNames = [];

    if (cotizadorKey === "roller") {
      classNames.push(selectedCortinaType === "duo" || selectedCortinaType === "roller-duo" ? "roller-duo" : "roller");
    } else if (cotizadorKey === "tradicional") {
      classNames.push("tela-tradicional");
    } else if (cotizadorKey === "madera") {
      classNames.push("tela-madera");
    } else if (cotizadorKey === "metal") {
      classNames.push("tela-metal");
    }

    const containers = classNames
      .map(className => productRoot.querySelector(`.hidden_selected_products.${className}`))
      .filter(Boolean);

    if (containers.length > 0) return containers;
    return Array.from(productRoot.querySelectorAll(".hidden_selected_products"));
  }

  function getQuoteItemSku(input) {
    return (input.dataset.productSku || input.dataset.skuSoftland || "").trim();
  }

  function getQuoteItemName(input, sku) {
    return (
      input.dataset.descripcionSoftland ||
      input.dataset.productTitle ||
      input.dataset.productName ||
      sku ||
      input.name ||
      ""
    ).trim();
  }

  function isQuoteProductInput(input) {
    if (!input || !input.name || !input.name.startsWith("product-")) return false;
    const linePrice = parseNumeric(input.value, 0);
    return getQuoteItemSku(input) && linePrice > 0 && linePrice < 999999;
  }

  function buildQuoteItemsFromHiddenProducts(container) {
    const root = container || document;
    const productInputs = [];
    const items = [];

    getActiveHiddenProductContainers(root).forEach(productContainer => {
      productInputs.push(...Array.from(productContainer.querySelectorAll("input[name^='product-']")));
    });

    productInputs.forEach(input => {
      if (!isQuoteProductInput(input)) return;

      const sku = getQuoteItemSku(input);
      const name = getQuoteItemName(input, sku);
      const linePrice = parseNumeric(input.value, 0);
      const quantity = 1;
      const unitPrice = parseNumeric(input.value, 0);

      items.push({
        sku,
        name,
        quantity,
        unitPrice,
        metadataJson: JSON.stringify({
          source: "shopify-theme",
          inputName: input.name,
          calculatedLinePrice: linePrice,
          productAvailable: input.dataset.productAvailable || "",
          productQuantity: input.dataset.productQuantity || ""
        })
      });
    });

    if (items.length > 0) return items;

    return [{
      sku: "COTIZA-B2C",
      name: "Cotización B2C",
      quantity: 1,
      unitPrice: 0,
      metadataJson: JSON.stringify({ source: "shopify-theme", fallback: true })
    }];
  }

  async function postCotizadorQuote(payload, options) {
    const opts = options || {};
    const container = opts.container || document.querySelector(".cotiza-cortina");
    const apiBaseUrl = getApiBaseUrl(container);
    if (!apiBaseUrl) throw new Error("No está configurado cotizador_api_base_url");

    const response = await fetch(`${apiBaseUrl}/api/v3/cotizador-b2c/quote`, {
      method: "POST",
      headers: buildCotizadorHeaders(container, true),
      credentials: "omit",
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      const message = await response.text();
      throw new Error(`Quote v3 failed (${response.status}): ${message}`);
    }

    return response.json();
  }

  async function postCotizadorTempProduct(payload, options) {
    const opts = options || {};
    const container = opts.container || document.querySelector(".cotiza-cortina");
    const apiBaseUrl = getApiBaseUrl(container);
    if (!apiBaseUrl) throw new Error("No está configurado cotizador_api_base_url");

    const response = await fetch(`${apiBaseUrl}/api/v3/cotizador-b2c/temp-product`, {
      method: "POST",
      headers: buildCotizadorHeaders(container, true),
      credentials: "omit",
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      const message = await response.text();
      throw new Error(`Temp product v3 failed (${response.status}): ${message}`);
    }

    return response.json();
  }

  function getCurrentCotizadorProductKey() {
    const cotizadorNode = document.querySelector(".cotiza51[data-cotizador]");
    const productKey = cotizadorNode && cotizadorNode.dataset ? cotizadorNode.dataset.cotizador : "";
    return (productKey || "").toString().trim().toLowerCase();
  }

  function getCurrentConfigurationPayload() {
    const configuration = {};
    const fieldNames = [
      "form-cortina-tipo",
      "form-confeccion-tipo",
      "form-ancho",
      "form-alto",
      "form-tela-tipo",
      "form-tela-suboption",
      "form-tela-opcion-color",
      "form-accionamiento-tipo",
      "form-caida-sentido",
      "form-cantidad-pano",
      "form-mando-posicion",
      "form-color-accesorio",
      "form-cortina-instalacion",
      "form-instalacion",
      "form-instalacion-region",
      "form-instalacion-comuna",
      "form-instalacion-direccion",
      "form-nombre",
      "form-mensaje"
    ];

    fieldNames.forEach(fieldName => {
      const input = document.querySelector(`input[name='${fieldName}']`);
      if (!input) return;

      const key = fieldName.replace(/^form-/, "").replace(/-/g, "_");
      const value = (input.dataset && input.dataset.value) || input.value || "";
      if (value !== "") {
        configuration[key] = value.toString();
      }
    });

    return configuration;
  }

  function getCurrentQuoteWeight() {
    const productKey = getCurrentCotizadorProductKey();
    const cortinaTypeInput = document.querySelector("input[name='form-cortina-tipo']");
    const selectedCortinaType = (cortinaTypeInput ? cortinaTypeInput.value : "").toString().trim().toLowerCase();
    const selectorByProductKey = {
      roller: selectedCortinaType === "duo" || selectedCortinaType === "roller-duo"
        ? "input[name='producto-peso-envio-duo']"
        : "input[name='producto-peso-envio']",
      tradicional: "input[name='producto-peso-envio-tradicional']",
      madera: "input[name='producto-peso-envio-madera']",
      metal: "input[name='producto-peso-envio-metal']"
    };

    const selector = selectorByProductKey[productKey];
    const input = selector ? document.querySelector(selector) : null;
    const grams = input && input.dataset ? parseNumeric(input.dataset.grams, null) : null;
    if (grams !== null) return grams / 1000;
    return input ? parseNumeric(input.value, 0) : 0;
  }

  function normalizeTempProductPayload(payload, quoteResponse) {
    const cotizaCortinaCabId = quoteResponse && Number.isFinite(Number(quoteResponse.cotizaCortinaCabId))
      ? Number(quoteResponse.cotizaCortinaCabId)
      : null;

    const normalized = {
      cotizaCortinaCabId,
      store: payload.store,
      productKey: payload.productKey || getCurrentCotizadorProductKey(),
      title: payload.title,
      calculatedPrice: parseNumeric(payload.calculatedPrice, parseNumeric(payload.price, 0)),
      currency: payload.currency || "CLP",
      weight: parseNumeric(payload.weight, getCurrentQuoteWeight()),
      weightUnit: payload.weightUnit || "kg",
      bodyHtml: payload.bodyHtml || payload.descriptionHtml || "",
      tags: payload.tags || ["cotizador-b2c", payload.productKey || getCurrentCotizadorProductKey()].filter(Boolean),
      configuration: payload.configuration || getCurrentConfigurationPayload(),
      sku: payload.sku || null,
      quantity: payload.quantity || 1
    };

    return normalized;
  }

  async function addVariantToShopifyCart(variantId, quantity) {
    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "include",
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] })
    });

    if (!response.ok) {
      const message = await response.text();
      throw new Error(`cart/add.js failed (${response.status}): ${message}`);
    }

    return response.json();
  }

  async function fetchShopifyCartState() {
    const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
      method: "GET",
      credentials: "include"
    });
    if (!response.ok) {
      const message = await response.text();
      throw new Error(`cart.js failed (${response.status}): ${message}`);
    }
    return response.json();
  }

  async function processCotizadorQuoteTempProductCart(payloads, options) {
    const opts = options || {};
    const quotePayload = payloads && payloads.quotePayload;
    const tempProductPayload = payloads && payloads.tempProductPayload;
    const quantity = payloads && payloads.quantity ? payloads.quantity : 1;

    if (!tempProductPayload) throw new Error("Temp product payload requerido");

    const normalizedTempProductPayload = normalizeTempProductPayload(tempProductPayload, null);
    const tempProductResponse = await postCotizadorTempProduct(normalizedTempProductPayload, opts);
    const variantId = tempProductResponse && tempProductResponse.variantId ? tempProductResponse.variantId : null;
    if (!variantId) {
      throw new Error("Temp product v3 no devolvió variantId");
    }

    const cartAddState = await addVariantToShopifyCart(variantId, quantity);
    const cartState = await fetchShopifyCartState();
    emitThemeCartUpdated(cartState);

    if (cartState && typeof update_mini_cart === "function") {
      update_mini_cart(true, true, true);
    }

    if (typeof refreshThemeHeaderCartFeedback === "function") {
      await refreshThemeHeaderCartFeedback();
    }

    return {
      quoteId: null,
      cotizaCortinaCabId: null,
      quoteResponse: null,
      tempProductResponse,
      variantId,
      cartAddState,
      cartState
    };
  }
  function emitThemeCartUpdated(cartState) {
    if (typeof window.emit === "function") {
      window.emit("quick-cart:updated");
      window.emit("cart:updated", { cart: cartState });
    }
    document.dispatchEvent(new CustomEvent("quick-cart:updated"));
    document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart: cartState } }));
  }

  function showCotizadorFunctionalError(message) {
    const safeMessage = message || "No se pudo procesar la cotización. Intenta nuevamente.";
    window.alert(safeMessage);
  }

  window.cotizadorBootstrapState = state;
  window.buildCotizadorProductStore = buildCotizadorProductStore;
  window.refreshCotizadorProductStoreFromDom = refreshCotizadorProductStoreFromDom;
  window.setCotizadorProductStoreFromBootstrap = setCotizadorProductStoreFromBootstrap;
  window.getCotizadorProductStore = getCotizadorProductStore;
  window.findCotizadorProducts = findCotizadorProducts;
  window.findCotizadorProduct = findCotizadorProduct;
  window.findCotizadorProductGroup = findCotizadorProductGroup;
  window.buildCotizadorComponentKeyMap = buildComponentKeyMap;
  window.fetchCotizadorBootstrap = fetchCotizadorBootstrap;
  window.applyCotizadorBootstrapToDom = applyCotizadorBootstrapToDom;
  window.getCotizadorStoreCode = getStoreCode;
  window.getCotizadorStoreEmailFallback = getStoreEmailFallback;
  window.buildQuoteItemsFromHiddenProducts = buildQuoteItemsFromHiddenProducts;
  window.postCotizadorQuote = postCotizadorQuote;
  window.postCotizadorTempProduct = postCotizadorTempProduct;
  window.processCotizadorQuoteTempProductCart = processCotizadorQuoteTempProductCart;
  window.addVariantToShopifyCart = addVariantToShopifyCart;
  window.fetchShopifyCartState = fetchShopifyCartState;
  window.emitThemeCartUpdated = emitThemeCartUpdated;
  window.showCotizadorFunctionalError = showCotizadorFunctionalError;
})();
